import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import {
  Container,
} from 'reactstrap';
import SalesOpportunitiesAdminContainer from '../../components/SalesOpportunitiesAdmin/SalesOpportunitiesAdminContainer';

class SalesOpportunitiesAdmin extends Component {

  render() {
    return (<Container fluid={true}>
      {/* <h1>Sales Opportunities</h1> */}
      <SalesOpportunitiesAdminContainer {...this.props} />
    </Container>)
  }
}

export default SalesOpportunitiesAdmin;
